var regionArr = [
	{
		"value": "320000",
		"label": "江苏省",
		"children": [{
			"value": "321000",
			"label": "扬州市",
			"children": [{
				"value": "321084",
				"label": "高邮市"
			},{
				"value": "321002",
				"label": "广陵区"
			}, {
				"value": "321003",
				"label": "邗江区"
			}, {
				"value": "321012",
				"label": "江都区"
			}, {
				"value": "321023",
				"label": "宝应县"
			}, {
				"value": "321081",
				"label": "仪征市"
			},  {
				"value": "321090",
				"label": "经济开发区"
			}]
		}, 
			{
				"value": "320100",
				"label": "南京市",
				"children": [{
					"value": "320102",
					"label": "玄武区"
				}, {
					"value": "320104",
					"label": "秦淮区"
				}, {
					"value": "320105",
					"label": "建邺区"
				}, {
					"value": "320106",
					"label": "鼓楼区"
				}, {
					"value": "320111",
					"label": "浦口区"
				}, {
					"value": "320113",
					"label": "栖霞区"
				}, {
					"value": "320114",
					"label": "雨花台区"
				}, {
					"value": "320115",
					"label": "江宁区"
				}, {
					"value": "320116",
					"label": "六合区"
				}, {
					"value": "320117",
					"label": "溧水区"
				}, {
					"value": "320118",
					"label": "高淳区"
				}]
			},
			{
				"value": "320500",
				"label": "苏州市",
				"children": [{
					"value": "320583",
					"label": "昆山市"
				},{
					"value": "320505",
					"label": "虎丘区"
				}, {
					"value": "320506",
					"label": "吴中区"
				}, {
					"value": "320507",
					"label": "相城区"
				}, {
					"value": "320508",
					"label": "姑苏区"
				}, {
					"value": "320509",
					"label": "吴江区"
				}, {
					"value": "320581",
					"label": "常熟市"
				}, {
					"value": "320582",
					"label": "张家港市"
				},  {
					"value": "320585",
					"label": "太仓市"
				}, {
					"value": "320590",
					"label": "工业园区"
				}, {
					"value": "320591",
					"label": "高新区"
				}]
			},
			{
				"value": "320200",
				"label": "无锡市",
				"children": [{
					"value": "320205",
					"label": "锡山区"
				}, {
					"value": "320206",
					"label": "惠山区"
				}, {
					"value": "320211",
					"label": "滨湖区"
				}, {
					"value": "320213",
					"label": "梁溪区"
				}, {
					"value": "320214",
					"label": "新吴区"
				}, {
					"value": "320281",
					"label": "江阴市"
				}, {
					"value": "320282",
					"label": "宜兴市"
				}]
			},
			{
				"value": "320600",
				"label": "南通市",
				"children": [{
					"value": "320602",
					"label": "崇川区"
				}, {
					"value": "320611",
					"label": "港闸区"
				}, {
					"value": "320612",
					"label": "通州区"
				}, {
					"value": "320623",
					"label": "如东县"
				}, {
					"value": "320681",
					"label": "启东市"
				}, {
					"value": "320682",
					"label": "如皋市"
				}, {
					"value": "320684",
					"label": "海门市"
				}, {
					"value": "320685",
					"label": "海安市"
				}, {
					"value": "320691",
					"label": "高新区"
				}]
			},
			
			
			{
			"value": "320300",
			"label": "徐州市",
			"children": [{
				"value": "320302",
				"label": "鼓楼区"
			}, {
				"value": "320303",
				"label": "云龙区"
			}, {
				"value": "320305",
				"label": "贾汪区"
			}, {
				"value": "320311",
				"label": "泉山区"
			}, {
				"value": "320312",
				"label": "铜山区"
			}, {
				"value": "320321",
				"label": "丰县"
			}, {
				"value": "320322",
				"label": "沛县"
			}, {
				"value": "320324",
				"label": "睢宁县"
			}, {
				"value": "320381",
				"label": "新沂市"
			}, {
				"value": "320382",
				"label": "邳州市"
			}, {
				"value": "320391",
				"label": "工业园区"
			}]
		},
			{
			"value": "320400",
			"label": "常州市",
			"children": [{
				"value": "320402",
				"label": "天宁区"
			}, {
				"value": "320404",
				"label": "钟楼区"
			}, {
				"value": "320411",
				"label": "新北区"
			}, {
				"value": "320412",
				"label": "武进区"
			}, {
				"value": "320413",
				"label": "金坛区"
			}, {
				"value": "320481",
				"label": "溧阳市"
			}]
		},
			
			{
			"value": "320700",
			"label": "连云港市",
			"children": [{
				"value": "320703",
				"label": "连云区"
			}, {
				"value": "320706",
				"label": "海州区"
			}, {
				"value": "320707",
				"label": "赣榆区"
			}, {
				"value": "320722",
				"label": "东海县"
			}, {
				"value": "320723",
				"label": "灌云县"
			}, {
				"value": "320724",
				"label": "灌南县"
			}]
		}, {
			"value": "320800",
			"label": "淮安市",
			"children": [{
				"value": "320803",
				"label": "淮安区"
			}, {
				"value": "320804",
				"label": "淮阴区"
			}, {
				"value": "320812",
				"label": "清江浦区"
			}, {
				"value": "320813",
				"label": "洪泽区"
			}, {
				"value": "320826",
				"label": "涟水县"
			}, {
				"value": "320830",
				"label": "盱眙县"
			}, {
				"value": "320831",
				"label": "金湖县"
			}, {
				"value": "320890",
				"label": "经济开发区"
			}]
		}, {
			"value": "320900",
			"label": "盐城市",
			"children": [{
				"value": "320902",
				"label": "亭湖区"
			}, {
				"value": "320903",
				"label": "盐都区"
			}, {
				"value": "320904",
				"label": "大丰区"
			}, {
				"value": "320921",
				"label": "响水县"
			}, {
				"value": "320922",
				"label": "滨海县"
			}, {
				"value": "320923",
				"label": "阜宁县"
			}, {
				"value": "320924",
				"label": "射阳县"
			}, {
				"value": "320925",
				"label": "建湖县"
			}, {
				"value": "320981",
				"label": "东台市"
			}]
		}, {
			"value": "321100",
			"label": "镇江市",
			"children": [{
				"value": "321102",
				"label": "京口区"
			}, {
				"value": "321111",
				"label": "润州区"
			}, {
				"value": "321112",
				"label": "丹徒区"
			}, {
				"value": "321181",
				"label": "丹阳市"
			}, {
				"value": "321182",
				"label": "扬中市"
			}, {
				"value": "321183",
				"label": "句容市"
			}]
		}, {
			"value": "321200",
			"label": "泰州市",
			"children": [{
				"value": "321202",
				"label": "海陵区"
			}, {
				"value": "321203",
				"label": "高港区"
			}, {
				"value": "321204",
				"label": "姜堰区"
			}, {
				"value": "321281",
				"label": "兴化市"
			}, {
				"value": "321282",
				"label": "靖江市"
			}, {
				"value": "321283",
				"label": "泰兴市"
			}]
		}, {
			"value": "321300",
			"label": "宿迁市",
			"children": [{
				"value": "321302",
				"label": "宿城区"
			}, {
				"value": "321311",
				"label": "宿豫区"
			}, {
				"value": "321322",
				"label": "沭阳县"
			}, {
				"value": "321323",
				"label": "泗阳县"
			}, {
				"value": "321324",
				"label": "泗洪县"
			}]
		}]
	}
]

export default regionArr
